.pill {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: var(--radius-pill);
  font-size: 12px;
  font-weight: var(--fw-semibold);
  line-height: 1;
  white-space: nowrap;
}

.sm {
  height: 22px;
  padding: 0 8px;
  font-size: 11px;
}

.info {
  background: var(--status-info-bg);
  color: var(--status-info-ink);
}

.waiting {
  background: var(--status-waiting-bg);
  color: var(--status-waiting-ink);
}

.done {
  background: var(--status-done-bg);
  color: var(--status-done-ink);
}

.neutral {
  background: var(--status-neutral-bg);
  color: var(--status-neutral-ink);
}

.problem {
  background: var(--status-problem-bg);
  color: var(--status-problem-ink);
}
